import Controller from "../class.Controller.js";
import TransporterLog from "../class.TransporterLog.js";

const LOGGER = new TransporterLog({
	attributes: {
		name: "TransporterAnalyticsMock",
		color: "cyan",
	},
});

export default class TransporterAnalyticsMock extends Controller {
	/**
	 * @param {object} options
	 * @param {object} options.attributes
	 * @param {TransporterAnalytics} options.attributes.controller
	 * @param {TransporterAnalytics} options.attributes.seen
	 */
	constructor(options) {
		super(options);

		this.enableLogs = false;
		this.playthroughs = [];
		this.items = [];
		this.trials = [];
	}

	run(alias, request, callback) {
		if (alias in this) {
			const result = this[alias](request);
			callback(!("error_code" in result), result);
		} else {
			callback(false, {
				error_code: "E_NO_ALIAS",
				error_msg: "Alias not implemented on mock.",
			});
		}
	}

	transporter_analytics_playthrough_get_id(request) {
		if (!request.force_new) {
			for (let i = this.playthroughs.length - 1; i >= 0; i--) {
				const playthrough = this.playthroughs[i];
				let found = true;
				for (let key in request) {
					if (playthrough[key] !== request[key]) {
						found = false;
						break;
					}
				}
				if (found) {
					return {response: i + 1};
				}
			}
		}
		const id = request.id || this.playthroughs.length || 1;
		this.playthroughs[id] = {
			id,
			collection_id: request.collection_id,
			document_id: request.document_id,
			version: request.version,
			user_id: request.user_id,
			class_id: request.class_id,
			completed_at: null,
			started_at: Math.floor(Date.now() / 1000),
			started_over_at: null,
			ta_reported_at: request.id ? Math.floor(Date.now() / 1000) : null,
			ta_updated_at: {},
			ta_needs_reported: !request.id,
		};
		this.playthroughs[id].ta_reported_at = this.getReportedAt(
			"playthroughs",
			this.playthroughs[id]
		);
		if (this.enableLogs) {
			LOGGER.log("playthroughs");
			console.table(this.playthroughs);
		}
		return {response: id};
	}

	transporter_analytics_playthrough_update(request) {
		const time = Date.now();
		if (this.playthroughs[request.id]) {
			for (let key in request) {
				if (key === "id" || key === "playthrough_id") {
					continue;
				}
				this.playthroughs[request.id][key] = request[key];
				this.playthroughs[request.id].ta_updated_at[key] = time;
			}
			this.playthroughs[request.id].ta_needs_reported = true;
			if (this.enableLogs) {
				LOGGER.log("playthroughs");
				console.table(this.playthroughs);
			}
			return {response: true};
		}
		return {error_code: "E_DB_ERROR", error_msg: "Invalid playthrough id."};
	}

	transporter_analytics_item_get_id(request) {
		let result = null;
		const {playthrough_id, pointer, context} = request;
		const results = this.items.filter((item) => {
			return (
				item.playthrough_id === playthrough_id &&
				item.pointer === pointer &&
				item.context === context
			);
		});
		if (results.length) {
			result = this.items.indexOf(results[0]) + 1;
		} else {
			const id = this.items.length || 1;
			this.items[id] = {
				id,
				playthrough_id: request.playthrough_id,
				pointer: request.pointer,
				context: request.context,
				type: request.type,
				user_interacted: request.user_interacted || false,
				started_at: request.started_at || Math.floor(Date.now() / 1000),
				completed_at: request.completed_at || null,
				ta_reported_at: null,
				ta_updated_at: {},
				ta_needs_reported: true,
			};
			this.items[id].ta_reported_at = this.getReportedAt(
				"items",
				this.items[id]
			);
			result = id;
		}
		if (this.enableLogs) {
			LOGGER.log("items");
			console.table(this.items);
		}
		return {response: result};
	}

	transporter_analytics_item_update(request) {
		const time = Date.now();
		if (this.items[request.id]) {
			for (let key in request) {
				if (key === "id" || key === "playthrough_id") {
					continue;
				}
				this.items[request.id][key] = request[key];
				this.items[request.id].ta_updated_at[key] = time;
			}
			this.items[request.id].ta_needs_reported = true;
			if (this.enableLogs) {
				LOGGER.log("items");
				console.table(this.items);
			}
			return {response: true};
		}
		return {error_code: "E_DB_ERROR", error_msg: "Invalid item id."};
	}

	transporter_analytics_trial_get_id(request) {
		let result = null;
		const {item_id, attempt} = request;
		const results = this.trials.filter((trial) => {
			return trial.item_id === item_id && trial.attempt === attempt;
		});
		if (results.length) {
			result = this.trials.indexOf(results[0]) + 1;
		} else {
			const id = this.trials.length || 1;
			this.trials[id] = {
				id,
				item_id: request.item_id,
				attempt: request.attempt,
				passed_at: request.passed_at || null,
				failed_at: request.failed_at || null,
				gave_up_at: request.gave_up_at || null,
				requested_hint_at: request.requested_hint_at || null,
				response: request.response || null,
				last_hint: _.isNumber(request.last_hint) ? request.last_hint : null,
				ta_reported_at: null,
				ta_updated_at: {},
				ta_needs_reported: true,
			};
			this.trials[id].ta_reported_at = this.getReportedAt(
				"trials",
				this.trials[id]
			);
			result = id;
		}
		if (this.enableLogs) {
			LOGGER.log("trials");
			console.table(this.trials);
		}
		return {response: result};
	}

	transporter_analytics_trial_update(request) {
		const time = Date.now();
		if (this.trials[request.id]) {
			for (let key in request) {
				if (key === "id" || key === "playthrough_id") {
					continue;
				}
				this.trials[request.id][key] = request[key];
				this.trials[request.id].ta_updated_at[key] = time;
			}
			this.trials[request.id].ta_needs_reported = true;
			if (this.enableLogs) {
				LOGGER.log("trials");
				console.table(this.trials);
			}
			return {response: true};
		}
		return {error_code: "E_DB_ERROR", error_msg: "Invalid trial id."};
	}

	getReportedAt(type, row) {
		let result = null;

		if (!this.seen) {
			return result;
		}

		if (type === "playthroughs") {
			result = Number.MAX_SAFE_INTEGER || Date.now();
		} else if (type === "items") {
			const seen = this.seen.items.filter((item) => {
				return (
					item.pointer === row.pointer &&
					(item.context === row.context ||
						parseInt(item.context) === parseInt(row.context))
				);
			});
			if (seen.length) {
				result = Number.MAX_SAFE_INTEGER || Date.now();
			}
		} else if (type === "trials") {
			const parent = this.items[row.item_id];
			const seen = this.seen.items.filter(
				(item) =>
					item.pointer === parent.pointer &&
					(item.context === parent.context ||
						parseInt(item.context) === parseInt(parent.context)) &&
					(item.last_attempt === row.attempt ||
						parseInt(item.last_attempt) >= row.attempt)
			);
			if (seen.length) {
				result = Number.MAX_SAFE_INTEGER || Date.now();
			}
		}

		return result;
	}

	// canReport(type, row) {
	// 	if (this.seen.completed) {
	// 		return false;
	// 	} else if (type === "items") {
	// 		const seen = this.seen.items.filter(item => {
	// 			return (
	// 				item.pointer === row.pointer &&
	// 				item.context === row.context &&
	// 				item.completed_at
	// 			);
	// 		});
	// 		LOGGER.warn("seen item", seen);
	// 		return !seen.length;
	// 	} else if (type === "trials") {
	// 		const parent = this.items[row.item_id];
	// 		const seen = this.seen.items.filter(
	// 			item =>
	// 				item.pointer === parent.pointer &&
	// 				item.context === parent.context &&
	// 				!isNaN(item.lastAttempt) &&
	// 				parseInt(item.last_attempt) <= row.attempt
	// 		);
	// 		LOGGER.warn("seen trial", seen);
	// 		return !seen.length;
	// 	} else {
	// 		return true;
	// 	}
	// }
}
